@if (comments().length > 0) {
  <button
    class="tt-comments-footer-button"
    data-testid="comments-footer-button"
    emphasis="minimal"
    ttButton
    variant="secondary"
    [attr.aria-label]="
      isOpen() ? ('Comments.CloseComments' | transloco) : ('Comments.OpenCommentsCount' | transloco: { count: openCommentsCount() })
    "
    [attr.aria-pressed]="isOpen()"
    (click)="handleToggle()">
    <mat-icon [icon]="'message-square-text'" [iconSize]="16" />
    <span class="tt-comments-footer-button_label">{{ 'Comments.Title' | transloco }}</span>
    @if (openCommentsCount() > 0) {
      <span aria-hidden="true" class="tt-comments-footer-button_count">{{ openCommentsCount() }}</span>
    }
  </button>
}
